import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import Helmet from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components/macro";

import {
  Link,
  Grid,
  Card as MuiCard,
  Typography,
  CardMedia,
  CardContent,
  Box,
  CircularProgress,
  Button,
} from "@material-ui/core";
import { spacing } from "@material-ui/system";
import { makeStyles } from '@material-ui/core/styles';
import {
  Divider,
  Spacer
} from "_components/common";
import { getSubscriptionAction } from "_redux/actions/subscriptionActions";

const Card = styled(MuiCard)(spacing);

const useStyles = makeStyles({
  root: {
    width: 300,
  },
  media: {
    height: 222,
  },
  content: {
    height: 200,
  }
});

const Wrapper = styled.div`
  padding: 0 8px;
  background: transparent;
`;

function SubscriptionCard({ plan, artwork }) {
  const classes = useStyles();
  return (
    <>
      <Grid container>
        <Grid item>
          <Card className={classes.root}>
            <CardMedia
              className={classes.media}
              image={plan.Product.img_url}
              title={plan.Product.name}
            />
          </Card>
        </Grid>
        <Grid item>
          <Wrapper>
            <Typography gutterBottom variant="body2" color="textSecondary" component="p">
              Name:
            </Typography>
            <Typography gutterBottom variant="body2" component="p">
              <b>{plan.Product.name}</b>
            </Typography>

            <Typography gutterBottom variant="body2" color="textSecondary" component="p">
              Plan ID:
            </Typography>
            <Typography gutterBottom variant="body2" component="p">
              <b>{plan.plan_key}</b>
            </Typography>


            <Typography gutterBottom variant="body2" color="textSecondary" component="p">
              Email
            </Typography>
            <Typography gutterBottom variant="body2" component="p">
              <b>{plan.Order.email}</b>
            </Typography>


            {/* <Spacer my={6} /> */}
            <Typography gutterBottom variant="body2" color="textSecondary" component="p">
              No. of tickets left:
            </Typography>
            <Typography gutterBottom variant="body2" component="p">
              <b>{plan.Subscription.number_of_tickets - plan.Tickets.length} out of {plan.Subscription.number_of_tickets}</b>
            </Typography>
          </Wrapper>
        </Grid>
      </Grid>
      <Spacer my={2}></Spacer>
      {/* <Grid container>
    <Grid item>
      <Typography gutterBottom variant="h5">
        {plan.Tickets.length} Redeemed Tickets:
      </Typography>      
      {plan.Tickets.map(t => {
        return (
          <Typography key={t.id} gutterBottom variant="body2" component="p">
            <b>{t.Event.title} {t.ticket_type === 'reserved' ? `${t.section} ${t.seat_row}${t.seat_number}` : ''} {t.ticket_type === 'virtual' ? `- Virtual Ticket` : ''}</b>
          </Typography>  
        )
      })}    
    </Grid>
  </Grid> */}
      <Spacer my={2}></Spacer>
      <Typography variant="h5" gutterBottom display="inline">
        Suggested Shows
      </Typography>
      <Grid container spacing={2}>
        {plan.Subscription.Events.filter((a, i) => plan.Subscription.Events.findIndex((s) => a.SeriesId === s.SeriesId) === i).map(e => {
          console.log('e.series', e.Series);
          return (
            <Grid item key={e.id}>
              <Link href={e.Series.url} target="_blank">
                <SeriesCard series={e.Series} artwork={artwork} />
                {e.Series.name}
              </Link>
            </Grid>
          )
        })}

      </Grid>
    </>
  )
}

function SeriesCard({ series, artwork }) {
  const classes = useStyles();
  console.log('seriesseriesseries', series);
  return (
    <Card className={classes.root}>
      <CardMedia
        className={classes.media}
        image={`https://res.cloudinary.com/onthestage/image/upload/h_150/${artwork[series.id]}`}
        title={series.name}
      />
    </Card>
  );
}

function Overview() {
  const { plans, artwork, error, isLoading } = useSelector((state) => state.subscriptionReducer);
  const { user } = useSelector((state) => state.authReducer);
  console.log('user', user);
  const dispatch = useDispatch();

  useEffect(() => {
    // dispatch to query API
    const loadData = async () => {
      await dispatch(getSubscriptionAction());
    };

    loadData();
  }, []);

  if (isLoading) {
    return <Box display="flex" justifyContent="center" my={6}>
      <CircularProgress />
    </Box>
  } else {
    return <>
      <Helmet title="Subscriptions Overview" />

      <Grid container>
        <Grid item>
          <Typography variant="h3" gutterBottom display="inline">
            Subscription Overview
          </Typography>
        </Grid>
        <Spacer my={2} />
        <Grid item>
          {plans.map(p => (
            <>
              <SubscriptionCard key={p.id} plan={p} artwork={artwork} />
              <Spacer my={16}></Spacer>
            </>
          ))}
        </Grid>
        <Spacer my={2} />
      </Grid>
    </>
  }
}

export default Overview;